import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOutlineState } from './outline.reducer';

export const selectOutlines = createFeatureSelector('outlines');

export const selectAllOutlines = createSelector(
  selectOutlines,
  (outlines: IOutlineState[]) => {
    return Object.values(outlines)
  }
);

export const selectPreparedAllOutlines = createSelector(
  selectAllOutlines,
  (outlines: IOutlineState[]) => {
    if(outlines.length) {
      const preparedOutlines = [];
      outlines.forEach((outline) => {
        outline.children = [];
        if(outline.level == 0) {
          preparedOutlines.push({...outline});
        } else {
          const lastItemIndex = preparedOutlines.length - 1;
          preparedOutlines[lastItemIndex] = setOutlineItem({...preparedOutlines[lastItemIndex]}, {...outline});
        }
      })
      return preparedOutlines;
    } else {
      return null;
    }
  }
);

function setOutlineItem(lastOutline, outline) {
  if(lastOutline.level + 1 == outline.level) {
    if(!lastOutline.children) {
      lastOutline.children = [];
    }
    lastOutline.children.push({...outline});
    return lastOutline;
  } else {
    const lastItemIndex = lastOutline.children.length - 1;
    lastOutline.children[lastItemIndex] = setOutlineItem({...lastOutline.children[lastItemIndex]}, {...outline});
    return lastOutline;
  }
}

